<script lang="ts">
  import { goToWikiCategoryList } from '../../../services'
  import { declination } from '../../../../../../helpers'
  import type { ICategory } from '../../../types'
  import { _ } from 'svelte-i18n'

  export let category: ICategory
</script>

<div class="category" on:click={() => goToWikiCategoryList(category.log_jump, category.pk)}>
  <div 
    class="image"
    style:background={`url("${category.image}")`} 
  />
  
  <div class="title text-grey text-bold">
    <span>{category.title}</span>
  </div>
  
  <div class="text text-grey">
    <span>{category.text}</span>
  </div>

  <div class="main__count">
    <div class="count">
      <i class="icon-file" />
      <span class='articles-count'>
        { declination(category.publications_count, $_('article'), $_('twoArticles'), $_('fiveArticles')) }
      </span>
    </div>
    
    <button type="button">
      <i class="icon-arrow-up text-grey" />
    </button>
  </div>
</div>

<style lang="scss">
  .icon-arrow-up {
    font-size: 12px;
    transform: rotate(90deg);
  }

  .category {
    display: flex;
    flex-direction: column;
    max-width: 406px;
    background: #FFFFFF;
    border: 2px solid #F0F0F0;
    border-radius: 10px;
    cursor: pointer;
    padding: 20px;
  }
 
  .image {
    height: 180px;
    background-size: cover !important;
    border-radius: 4px;
    background-position: center !important;

    @media (max-width: 576px) {
      height: 127px;
    }

    @media (max-width: 500px) {
      height: 200px;
    }
  }

  .title {
    font-size: 16px;
    line-height: 23px;
    padding-top: 16px;
  }

  .text {
    font-size: 14px;
    line-height: 20px; 
    padding-top: 4px;
    border-bottom: 1px solid #BDBFC4;
    padding-bottom: 16px;
  }

  .main__count {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-top: 17px;
    align-items: center;
  }

  .count {
    display: flex;
    align-items: center;
    color:#BDBFC4;
    fill: #BDBFC4;
  }

  button {
    height: 30px;
    width: 30px;
    position: relative;
    overflow: hidden;
    background-color: white; 
    border: none;
    background: #F3F3F4;
    border-radius: 50%;
    cursor: pointer;
    opacity:.8;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  button:hover {
    background: #BDBFC4;
  }

  button:hover i {
    color: white;
  }

  .articles-count {
    padding-left: 6px;
    text-transform: uppercase;
    font-size: 14px;
  } 
</style>
